import React from 'react'
import { compose } from 'redux'
import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'app-types'

import messages from '../../i18n'
import { form, FormInterface, intl, IntlInterface, wizard, WizardInterface } from '../../hoc'
import validate from './SmsVerify.validate'
import { clientSelectors, modalDialogActions, signingActions, signingSelectors } from '../../redux'
import { SmsForm } from './components'

type ReduxProps = ConnectedProps<typeof connector>

type Props = WizardInterface & IntlInterface & FormInterface & ReduxProps

export const SmsVerify = ({
  didSendFirstSms,
  handleSubmit,
  hideAllModalDialogs,
  phoneNumber,
  setErrors,
  submitCode,
  translate,
  sendSms,
  smsSendResponse,
  smsVerifyResponse,
  wizard,
}: Props) => {
  const verifySms = () => {
    handleSubmit(() =>
      submitCode({
        success: () => {
          hideAllModalDialogs()
          wizard.gotoNext()
        },
        error: () =>
          setErrors('Signing', { verificationCode: translate(messages.smsVerify.invalidCode) }),
      })
    )()
  }

  return (
    <SmsForm
      close={hideAllModalDialogs}
      didSendFirstSms={didSendFirstSms}
      verifySms={verifySms}
      phone={phoneNumber}
      sendSms={sendSms}
      smsSendResponse={smsSendResponse}
      smsVerifyResponse={smsVerifyResponse}
      translate={translate}
    />
  )
}

const connector = connect(
  (state: ReduxState) => ({
    didSendFirstSms: signingSelectors.didSendFirstSms(state),
    phoneNumber: clientSelectors.selectPhoneNumber(state),
    smsSendResponse: signingSelectors.getSmsSendResponse(state),
    smsVerifyResponse: signingSelectors.getVerificationCode(state),
  }),
  {
    hideAllModalDialogs: modalDialogActions.hideAllModalDialogs,
    sendSms: signingActions.sendSms,
    submitCode: signingActions.submitCode,
  }
)

const enhance = compose(
  wizard,
  intl,
  form({ destroyOnUnmount: true, name: 'Signing', validate }),
  connector
)

export default enhance(SmsVerify)
